console.timeEnd('JS Start')

const APP = require('APP')
const $ = require('jquery')
const Backbone = require('backbone')

const router = require('router')
const { setServerClientTimeDiff } = require('../app/utils/dates')
require('Helpers/isMobile')
require('GameFrameModule')

require('./sass/play/play_all.scss')

APP.USE_FOS_ROUTING = true

window.jQuery = window.$ = Backbone.$ = $

router.historyStart()

setServerClientTimeDiff(APP.serverDate, APP.timezone)
